<template>
  <div class="backdrop" @click.self="$emit('close')">
    <div class="modal">
      <!-- <over-loading v-if="loading" /> -->
      <button type="button" class="close" @click="$emit('close')">
        &times;
      </button>
      <form v-if="step == 1" @submit.prevent="editSubmit()">
        <h2>
          {{
            isMobile
              ? data.mobileNumber
                ? lang.editMobile
                : lang.registerMobile
              : data.email
              ? lang.editEmail
              : lang.registerEmail
          }}
        </h2>

        <div
          v-if="
            (isMobile ? data.mobileNumber : data.email) &&
            !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
              data.authenticationType
            )
          "
        >
          <LabelInput
            :type="isMobile ? 'nochar' : ''"
            :value="oldField"
            :label="isMobile ? lang.currentMobile : lang.currentEmail"
            dir="ltr"
            @input="
              (value) =>
                isMobile ? (oldField = $A2N(value)) : (oldField = value)
            "
          >
            <template #prepend>
              <div v-if="isMobile" class="prepend">
                {{ countryPhoneCode }}
              </div>
            </template>
          </LabelInput>
        </div>
        <div>
          <LabelInput
            :type="isMobile ? 'nochar' : ''"
            :value="newField"
            :label="
              isMobile
                ? data.mobileNumber
                  ? lang.newMobile
                  : lang.mobileNumber
                : data.email
                ? lang.newEmail
                : lang.email
            "
            dir="ltr"
            @input="(value) => (newField = value)"
          >
            <template #prepend>
              <div v-if="isMobile" class="prepend">
                {{ countryPhoneCode }}
              </div>
            </template>
          </LabelInput>
        </div>
        <button
          class="flat-button"
          type="submit"
          :disabled="
            (isMobile
              ? newField.length != 10 ||
                (data.mobileNumber &&
                  !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
                    data.authenticationType
                  ) &&
                  oldField.length != 10)
              : !$validEmail(newField) ||
                (data.email &&
                  !['UNAUTHORIZED', 'UNIDENTIFIED', 'NOT_COMPLETE'].includes(
                    data.authenticationType
                  ) &&
                  !$validEmail(oldField))) || newField == oldField
          "
        >
          {{ lang.continue }}
        </button>
      </form>
      <form v-else-if="step == 2" @submit.prevent="submitOTP">
        <div>
          <h2>{{ lang.otp }}</h2>
          <p style="text-align: center; margin-top: 16px">
            {{
              isMobile ? lang.otpDescriptionMobile : lang.otpDescriptionEmail
            }}
          </p>
        </div>
        <div
          dir="ltr"
          class="otp-div"
          :class="{ focus: otp.toString().length }"
        >
          <!-- @paste="paste" -->
          <CodeInput
            :loading="false"
            class="code-input"
            @change="onChange($event)"
            @complete="submitOTP"
            :fields="num"
            ref="code-input"
            :fieldWidth="40"
            :fieldHeight="40"
          />
        </div>
        <button
          class="flat-button"
          :type="countDown ? 'submit' : 'reset'"
          @click.prevent="countDown ? submitOTP() : resend()"
          :disabled="
            countDown ? otp.toString().length < num || state.miniLoading : false
          "
        >
          {{
            countDown
              ? (isMobile ? lang.editMobile : lang.editEmail) +
                " ( " +
                countDown +
                "s )"
              : state.lang.tryAgain
          }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
// import OverLoading from "@/components/tools/over-loading";
import CodeInput from "vue-verification-code-input";
// import { paste } from "@/library/reuseableFunction";
export default {
  name: "EditMobileEmail",
  components: {
    // OverLoading,
    CodeInput,
  },
  props: ["data", "isMobile", "countryPhoneCode"],
  data() {
    return {
      lang: this.$languageDict().profile.personalFields.editModal,
      step: 1,
      oldField: "",
      newField: "",
      loading: false,
      countDown: 120,
      num: 6,
      otp: "",
    };
  },
  methods: {
    async editSubmit() {
      this.loading = true;
      const body = {};
      if (this.isMobile) {
        body.oldMobileNumber = this.oldField
          ? this.mobileFormatter(this.oldField)
          : null;
        body.newMobileNumber = this.mobileFormatter(this.newField);
      } else {
        body.oldEmail = this.oldField;
        body.newEmail = this.newField;
      }
      try {
        const res = await this.$axios.post(
          this.isMobile ? "/users/change-mobile" : "/users/change-email",
          body
        );
        this.loading = false;
        if (res.baseDTO.otpMobile && res.baseDTO.otpMobile == "FINOTECH") {
          this.num = 5;
        }
        this.step = 2;
        this.$nextTick(() => {
          this.countDownTimer();
          this.setPlaceholder();
        });
      } catch (error) {
        this.loading = false;
      }
    },
    setPlaceholder() {
      for (let i = 0; i < this.num; i++) {
        this.$refs["code-input"].$refs["input_" + i][0].placeholder = "---";
      }
      this.$refs["code-input"].$refs["input_0"][0].focus();
    },
    onChange(e) {
      this.otp = e;
    },

    // paste,
    async countDownTimer() {
      if (this.countDown > 0) {
        this.timeOut = setTimeout(() => {
          this.countDown--;
          this.countDownTimer();
        }, 1000);
      } else {
        const res = await this.$error(
          this.state.lang.endTime,
          "",
          "info",
          this.state.lang.tryAgain
        );
        if (res.isConfirmed) {
          this.resend();
        }
      }
    },
    async resend() {
      this.state.miniLoading = true;
      this.reset();
      await this.$axios.post(
        this.isMobile ? "/users/resend-mobile-otp" : "/users/resend-email-otp"
      );

      this.$error(this.lang.resentMessage, "", "success");
      this.$cookies.set("username", this.state.userInfo.email);
      if (this.countDown === 0) {
        this.countDown = 120;
        this.countDownTimer();
      }
    },
    async submitOTP() {
      this.loading = true;
      try {
        const res = await this.$axios.post(
          this.isMobile
            ? "/users/change-mobile-otp"
            : "/users/change-email-otp",
          {
            otp: this.otp,
          }
        );
        this.loading = false;
        this.$error(
          "",
          this.isMobile ? this.lang.editedmobile : this.lang.editedEmail,
          "success"
        );
        if (this.isMobile) {
          this.$emit(
            "changedMobile",
            this.state.userInfo.authorized
              ? res.baseDTO.mobileNumber
              : this.newField
          );
        } else {
          this.$emit(
            "changedEmail",
            this.state.userInfo.authorized ? res.baseDTO.email : this.newField
          );
        }
        this.$emit("close");
      } catch (error) {
        this.loading = false;
      }
    },
    reset() {
      this.otp = "";
      for (let i = 0; i < this.num; i++) {
        this.$refs["code-input"].values[i] = "";
        this.$refs["code-input"].$refs["input_" + i][0].value = "";
      }
      this.$refs["code-input"].$refs["input_0"][0].focus();
    },
    mobileFormatter(mobile) {
      return this.countryPhoneCode + mobile;
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
};
</script>

<style lang="scss" scoped>
[dir="rtl"] .backdrop {
  left: 0;
  right: 44px;
}
.backdrop {
  position: fixed;
  top: 0;
  left: 44px;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  z-index: 100;
  padding: 16px;
  .modal {
    max-width: 380px;
    width: 100%;
    background-color: #030920;
    border-radius: 16px;
    position: relative;
    .close {
      position: absolute;
      top: 0px;
      left: 12px;
      font-size: 40px;
      cursor: pointer;
      color: #fff;
      background-color: transparent;
    }
    form {
      width: 100%;
      height: 330px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    h2 {
      text-align: center;
      margin: 0;
    }
    label {
      display: block;
      margin-block: 12px;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.otp-div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: solid 1px var(--border);
  border-radius: 5px;
  padding: 8px;
  direction: ltr;
  height: 50px;

  &.focus {
    border-color: var(--green);
    border-width: 2px;
  }
}
::v-deep .otp-div * {
  direction: ltr !important;
  color: #cb07c3 !important;
}
::v-deep .otp-div input {
  background-color: #13142a;
}

input[type="tel"]::placeholder {
  color: var(--main-color);
}
::v-deep .code-input {
  width: 100% !important;
  max-width: 250px;

  .react-code-input {
    display: flex;
    justify-content: space-evenly;
    border: none;

    input {
      border: none !important;
      color: var(--fontcolor) !important;
      font-family: Yekan, sans-serif !important;
      font-size: 25px;
      letter-spacing: -2px;
      text-align: center !important;
    }
  }
}
.flat-button {
  background: linear-gradient(
    90deg,
    #1a97bf 2.72%,
    #721ac9 28.48%,
    #ab0ae3 62.88%,
    #c102c5 78.84%,
    #bb1396 100%
  );
  border-radius: 8px;
  height: 35px;
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  color: #fcfcfc;
  font-size: clamp(14px, 1.5vw, 16px);
}
[dir="rtl"] .prepend {
  margin-left: 10px;
}
.prepend {
  direction: ltr;
}
</style>
